import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBarsStaggered, faEnvelope, faPhone, faRobot } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faLinkedin, faWhatsapp, faThreads } from '@fortawesome/free-brands-svg-icons'
import { useEffect, useState } from 'react'

import { APPVERSION, APPVERSIONDATE, URL_STRAPI, API_TOKEN_STRAPI } from '../core.js'
import CTAButton from './CTAButton.js'
import axios from 'axios';

import './MainFooter.css'

export default function MainFooter(props) {

    const [uptimestatus, setUptimestatus] = useState(null);

    const fetchUptimestatus = async () => {
        try {
            const res = await axios.get(`${URL_STRAPI}/api/uptimestatus`, {
                params: {
                    'populate': '*',
                },
                headers: {
                    Authorization: `Bearer ${API_TOKEN_STRAPI}`,
                },
                timeout: 5000,
            });
            console.log(res.data);

            return res.data;
        } catch (err) {
            console.error('Fehler beim Laden des Serverstatus:', err.message || err);
            return null;
        }
    };
    useEffect(() => {
        fetchUptimestatus().then((content) => { setUptimestatus(content) });

    }, [])

    return (
        <div className='mainfooter_div'>

            {(props.hidecontact == true) ? <></> :

                <div className='mainfooter_contact' id='contactus'>
                    <h2>Wir sind für dich da.</h2>
                    <p>Erreiche uns so, wie es dir am liebsten ist.</p>
                    <a href='/chat'><FontAwesomeIcon className='contacticon' icon={faRobot} /> Fragen? Chatte mit Assistent ToNi</a>
                    <a href='mailto:hey@tonetwork.de'><FontAwesomeIcon className='contacticon' icon={faEnvelope} /> hey@tonetwork.de</a>
                    <a href='tel:083324908872'><FontAwesomeIcon className='contacticon' icon={faPhone} />  08332 4908872</a>
                    <a href='https://wa.me/+4915792358626' target='_blank' rel='noopener'><FontAwesomeIcon className='contacticon' icon={faWhatsapp} /> 01579 2358626</a>
                    <a href='https://instagram.com/tonetwork.de' target='_blank' rel='noopener'><FontAwesomeIcon className='contacticon' icon={faInstagram} /> tonetwork.de</a>

                    <CTAButton className="contact_cta" showArrow={true} lightcta={true} customIcon={false} iconLeft={false} title={"Zum Kontaktbereich"} href={'/support'}></CTAButton>

                </div>
            }

            <div className='mainfooter_bottom'>
                <p>©2021-2026 <a href="/" title="Zur Startseite" style={{ textDecoration: 'none' }}><b>ToNetwork UG (h.)</b></a></p>
                <div className='footerlinks'>
                    <a href='/rechtliches'>Rechtliche Hinweise</a>

                    {/* <button type="button" id="hs_show_banner_button"
                        //                     style="background-color: #425b76; border: 1px solid #425b76;
                        //    border-radius: 3px; padding: 10px 16px; text-decoration: none; color: #fff;
                        //    font-family: inherit; font-size: inherit; font-weight: normal; line-height: inherit;
                        //    text-align: left; text-shadow: none;"
                        onClick={() => {
                            var _hsp = window._hsp = window._hsp || [];
                            _hsp.push(['showBanner']);
                        }}
                    >
                        Cookie-Einstellungen
                    </button> */}


                    <a href='http://uptime-status.tonetwork.de' target='_blank' rel='noopener'>
                        Serverstatus
                        <div id='uptimestatus_badge'
                            dangerouslySetInnerHTML={{ __html: uptimestatus }}
                        /></a>
                </div>
                <div className='mainfooter_socials'>
                    <a href='/linktree' title='Linktree' aria-label='Linktree'><FontAwesomeIcon icon={faBarsStaggered} /></a>
                    <a href='https://instagram.com/tonetwork.de' title='@tonetwork.de' aria-label='ToNetwork auf Instagram' target='_blank' rel='noopener'><FontAwesomeIcon icon={faInstagram} /></a>
                    <a href='https://linkedin.com/company/tonetwork' title='linkedin.com/company/tonetwork' aria-label='ToNetwork auf LinkedIn' target='_blank' rel='noopener'><FontAwesomeIcon icon={faLinkedin} /></a>
                    <a href='https://wa.me/+4915792358626' title='01579 235 8626' aria-label='ToNetwork via WhatsApp' target='_blank' rel='noopener'><FontAwesomeIcon icon={faWhatsapp} /></a>
                    <a href='https://threads.net/@tonetwork.de' title='@tonetwork.de' aria-label='ToNetwork auf Threads' target='_blank' rel='noopener'><FontAwesomeIcon icon={faThreads} /></a>
                    <a href='/chat' title='ToNi KI Assistent' aria-label='ToNi KI Assistent' target='_blank'><FontAwesomeIcon icon={faRobot} /></a>
                </div>
                <p className='footer_versioninfo'>tonweb3.0_v{APPVERSION} #{APPVERSIONDATE}</p>
            </div >

        </div >
    )
}